import { Environment } from '@shared/abstraction/environment';

const apiBaseUrl = '#{APIBASEURL}#'; // Value to be replaced by environment variable

export const environment: Environment = {
  production: true,
  apiBaseUrl,
  sessionTime: 60 * 9, // 9 minutes
  timeBeforeClose: 60, // 60 seconds
  devExpressApiKey: '',
};
